import { useState } from "react";
import { Heart, Loader2, Coffee } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import api from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

const AMOUNTS = [3, 5, 10];
const CURRENCIES = [
  { code: "usd", symbol: "$", label: "USD" },
  { code: "sgd", symbol: "S$", label: "SGD" },
];

export default function SupportModal({ open, onOpenChange }) {
  const { user } = useAuth();
  const [currency, setCurrency] = useState("usd");
  const [loading, setLoading] = useState(null);

  const cur = CURRENCIES.find((c) => c.code === currency);

  const donate = async (amount) => {
    setLoading(amount);
    try {
      const { data } = await api.post("/payments/checkout", {
        lookup_key: `tip_${amount}_${currency}`,
        origin_url: window.location.origin,
        user_id: user?.user_id,
      });
      window.location.href = data.checkout_url;
    } catch (e) {
      setLoading(null);
      toast.error(e?.response?.data?.detail || "Couldn't start checkout. Please try again.");
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-surface border-line text-ink sm:max-w-md" data-testid="support-modal">
        <DialogHeader>
          <div className="w-12 h-12 rounded-xl bg-brand-soft border border-brand/30 flex items-center justify-center mb-2">
            <Heart className="w-6 h-6 text-brand" />
          </div>
          <DialogTitle className="font-display text-xl">Support GetInterviewed</DialogTitle>
          <DialogDescription className="text-body">
            GetInterviewed is free forever — no paywalls, no Pro tier. If it helped your job search, a small tip keeps it running for everyone.
          </DialogDescription>
        </DialogHeader>

        {/* Currency toggle */}
        <div className="flex items-center gap-2 justify-center">
          {CURRENCIES.map((c) => (
            <button
              key={c.code}
              data-testid={`support-currency-${c.code}`}
              onClick={() => setCurrency(c.code)}
              className={`px-4 py-1.5 rounded-xl text-sm font-medium border transition-colors ${
 currency === c.code
 ? "bg-brand-soft border-brand/40 text-brand"
 : "border-line text-body hover:bg-subtle"
 }`}
            >
              {c.symbol} {c.label}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-3 gap-3 mt-2">
          {AMOUNTS.map((a) => (
            <button
              key={a}
              data-testid={`support-tip-${a}`}
              onClick={() => donate(a)}
              disabled={loading !== null}
              className="flex flex-col items-center gap-1 py-5 rounded-xl border border-line bg-canvas hover:border-brand/50 hover:bg-brand-soft transition-colors disabled:opacity-50"
            >
              {loading === a ? (
                <Loader2 className="w-6 h-6 text-brand animate-spin" />
              ) : (
                <>
                  <Coffee className="w-5 h-5 text-brand" />
                  <span className="font-display text-lg font-bold">{cur.symbol}{a}</span>
                </>
              )}
            </button>
          ))}
        </div>
        <p className="text-center text-xs text-faint font-mono2 mt-1">Secure one-time payment via Stripe · Test card 4242 4242 4242 4242</p>
      </DialogContent>
    </Dialog>
  );
}
